import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagecreator',
  templateUrl: './pagecreator.component.html',
  styleUrls: ['./pagecreator.component.scss']
})
export class PagecreatorComponent implements OnInit {

  //public currentPage : Page;

  public createNewPage(pageName : string) {
  //  this.currentPage = new Page(pageName);
  }

  constructor() { }

  ngOnInit() {
  }

}
